// const tests = {
//     "tests":[
//         {
//             "shift": {
//                 "start_time_day": "lun",
//                 "end_time_day": "dom",
//                 "start_time_hour": 21,
//                 "end_time_hour": 8,
//                 "start_time_minute": 30,
//                 "end_time_minute": 0
//             },
//             "date": "2022-01-01 08:01:00",
//             "expected": {
//                 "successfull": false
//             }
//         },
//         {
//             "shift": {
//                 "start_time_day": "lun",
//                 "end_time_day": "dom",
//                 "start_time_hour": 21,
//                 "end_time_hour": 8,
//                 "start_time_minute": 30,
//                 "end_time_minute": 0
//             },
//             "date": "2022-01-01 07:30:00",
//             "expected": {
//                 "successfull": true,
//                 "st": "2021-12-31 21:30:00",
//                 "et": "2022-01-01 08:00:00"
//             }
//         },
//         {
//             "shift": {
//                 "start_time_day": "mie",
//                 "end_time_day": "LUN",
//                 "start_time_hour": 21,
//                 "end_time_hour": 8,
//                 "start_time_minute": 30,
//                 "end_time_minute": 0
//             },
//             "date": "2022-08-02 07:30:00",
//             "expected": {
//                 "successfull": true,
//                 "st": "2022-08-01 21:30:00",
//                 "et": "2022-08-02 08:00:00"
//             }
//         },
//         {
//             "shift": {
//                 "start_time_day": "jue",
//                 "end_time_day": "LUN",
//                 "start_time_hour": 8,
//                 "end_time_hour": 15,
//                 "start_time_minute": 30,
//                 "end_time_minute": 30
//             },
//             "date": "2022-08-01 07:30:00",
//             "expected": {
//                 "successfull": false
//             }
//         },
//         {
//             "shift": {
//                 "start_time_day": "jue",
//                 "end_time_day": "LUN",
//                 "start_time_hour": 8,
//                 "end_time_hour": 15,
//                 "start_time_minute": 30,
//                 "end_time_minute": 30
//             },
//             "date": "2022-08-01 09:30:00",
//             "expected": {
//                 "successfull": true,
//                 "st": "2022-08-01 08:30:00",
//                 "et": "2022-08-01 15:30:00"
//             }
//         },
//         {
//             "shift": {
//                 "start_time_day": "dom",
//                 "end_time_day": "LUN",
//                 "start_time_hour": 21,
//                 "end_time_hour": 8,
//                 "start_time_minute": 30,
//                 "end_time_minute": 30
//             },
//             "date": "2022-08-02 07:30:00",
//             "expected": {
//                 "successfull": true,
//                 "st": "2022-08-01 21:30:00",
//                 "et": "2022-08-02 08:30:00"
//             }
//         }
//     ]
// };

const isDayInShift = (shift, date) => {
    if (isNaN(getShiftWeekDayAtEndHour(shift, date))) return false;
    return true;
}

const getNextWeekDay = (dayIdx) => {
    const daysOfWeek = ['dom', 'lun', 'mar', 'mie', 'jue', 'vie', 'sab'];
    if (dayIdx + 1 == daysOfWeek.length) return 0;
    return dayIdx + 1;
}

const getShiftWeekDayAtEndHour = (shift, date) => {
    // const daysOfWeek = ['dom', 'lun', 'mar', 'mie', 'jue', 'vie', 'sab'];
    var dayOfWeek = date.getDay();
    // const startDayStr = shift.start_time_day;
    // const endDayStr = shift.end_time_day;
    const startDayIdx = shift.start_time_day > 6? 0: shift.start_time_day;
    let endDayIdx = shift.end_time_day > 6? 0: shift.end_time_day;
    // const startDayIdx = daysOfWeek.indexOf(startDayStr.toLowerCase());
    // let endDayIdx = daysOfWeek.indexOf(endDayStr.toLowerCase());

    let endDayAtEndTime = endDayIdx;
    let dayAfterEndDay = getNextWeekDay(endDayIdx);

    const startTime = shift.start_time_hour * 60 + shift.start_time_minute;
    const endTime = shift.end_time_hour * 60 + shift.end_time_minute;
    if (endTime < startTime && startDayIdx != dayAfterEndDay) {
        endDayAtEndTime = dayAfterEndDay;
    }

    if (endDayAtEndTime >= startDayIdx && dayOfWeek >= startDayIdx && dayOfWeek <= endDayAtEndTime) {
        return endDayAtEndTime;
    }
    if (endDayAtEndTime < startDayIdx && (dayOfWeek >= startDayIdx || dayOfWeek <= endDayAtEndTime)) {
        return endDayAtEndTime;
    }

		/*console.log("No existe turno para el dia ", {
			shift, date,
			startTime,
			endTime,
			endDayAtEndTime,
			startDayIdx,
			startDayStr,
			endDayStr,
			endDayIdx,
			dayOfWeek,
			dayAfterEndDay
		})*/
    return NaN;
}

export const isFromPreviousDayShift = (shift, ts: Date)=>{
    const shiftBounds = getShiftTimeBoundsByTimestamp(shift, ts);
    // console.log('stest shift bounds at date ', {shift, ts, shiftBounds})
    if(shiftBounds == undefined ) return false; //PARCHE: TODO: QUE PASA SI NO ENCUENTRA LOS BOUNDS? IGUAL HAY QUE CAMBIAR A SHIFT SESSIONS
    if(shiftBounds.st.getDate() === shiftBounds.et.getDate()) return false; // No es un turno de media noche
    if(shiftBounds.st.getTime() > ts.getTime()) return false; // La fecha está fuera del turno
    if(shiftBounds.st.getDate() === ts.getDate()) return false; //La fecha es del dia del inicio del turno
    return ts.getTime() <= shiftBounds.et.getTime(); // Si es de media noche, entonces es del dia anterior
}

export const getShiftTimeBoundsByTimestamp = (shift, date, options = {}) => {
	/*console.log("get shift time bounds by timestamp params: ", {
		shift, date, options
	})*/
    // const daysOfWeek = ['dom', 'lun', 'mar', 'mie', 'jue', 'vie', 'sab'];
    var dayOfWeek = date.getDay(); //idx 2 = 'mar'
    // const startDayStr = shift.start_time_day;
    // const endDayStr = shift.end_time_day;
    // const startDayIdx = daysOfWeek.indexOf(startDayStr.toLowerCase());
    const startDayIdx = shift.start_time_day > 6? 0: shift.start_time_day;
    let endDayIdx = shift.end_time_day > 6? 0: shift.end_time_day;

    var st = null;
    var et = null;

    const startTime = shift.start_time_hour * 60 + shift.start_time_minute;
    const endTime = shift.end_time_hour * 60 + shift.end_time_minute;
    let currentTime = date.getHours() * 60 + date.getMinutes();
    // let endDayIdx = daysOfWeek.indexOf(endDayStr.toLowerCase());

    const shiftWeekDayAtEndHour = getShiftWeekDayAtEndHour(shift, date);
    if (!isDayInShift(shift, date)){
    //   console.log("el dia no esta en turno")
      return null;
    }

		if(options['ignoreTime'] == true){
			currentTime = startTime;
			if(getNextWeekDay(endDayIdx) == shiftWeekDayAtEndHour && dayOfWeek == shiftWeekDayAtEndHour
				&& endTime < startTime){
				currentTime = endTime;
			}
    }

    if (getNextWeekDay(endDayIdx) == shiftWeekDayAtEndHour && dayOfWeek == shiftWeekDayAtEndHour
        && endTime < startTime && currentTime <= endTime) {
        st = new Date(date);
        st.setDate(st.getDate() - 1);
        st.setHours(shift.start_time_hour);
        st.setMinutes(shift.start_time_minute);
        st.setSeconds(0);
        st.setMilliseconds(0);

        et = new Date(date);
        et.setHours(shift.end_time_hour);
        et.setMinutes(shift.end_time_minute);
        et.setSeconds(0);
        et.setMilliseconds(0);
			/*console.log("stest Caso 1 ", {
				endDayIdx: endDayIdx,
				shiftWeekDayAtEndHour,
				dayOfWeek,
				endTime,
				startTime,
				currentTime,
				date,
				shift,
				et,st
			})*/
        return { st, et }
    }
    if (endTime < startTime && (currentTime >= startTime || currentTime <= endTime)) {
        st = new Date(date);
        et = new Date(date);

        if(currentTime>=startTime){
            et.setDate(et.getDate()+1);
        }

        if(currentTime<=endTime){
            st.setDate(st.getDate()-1);
        }

        st.setHours(shift.start_time_hour);
        st.setMinutes(shift.start_time_minute);
        st.setSeconds(0);
        st.setMilliseconds(0);

        et.setHours(shift.end_time_hour);
        et.setMinutes(shift.end_time_minute);
        et.setSeconds(0);
        et.setMilliseconds(0);
				const _et = new Date(et);
			/*console.log("stest Caso 2 ", {
				endDayIdx: endDayIdx,
				shiftWeekDayAtEndHour,
				dayOfWeek,
				endTime,
				startTime,
				currentTime,
				date,
				shift,
				et: _et,st
			})*/
        return { st, et }
    }
    if (endTime >= startTime && currentTime >= startTime && currentTime <= endTime) {
        st = new Date(date);
        st.setHours(shift.start_time_hour);
        st.setMinutes(shift.start_time_minute);
        st.setSeconds(0);
        st.setMilliseconds(0);

        et = new Date(date);
        et.setDate(et.getDate());
        et.setHours(shift.end_time_hour);
        et.setMinutes(shift.end_time_minute);
        et.setSeconds(0);
        et.setMilliseconds(0);
			/*console.log("stest Caso 3 ", {
				endDayIdx: endDayIdx,
				shiftWeekDayAtEndHour,
				dayOfWeek,
				endTime,
				startTime,
				currentTime,
				date,
				shift,
				et,st
			})*/
        return { st, et }
    }
    // console.log(`no se pudo encontrar limites de tiempo para el turno `, {date, shift, endTime, startTime, currentTime})
    return null;
}

// export const inShiftBounds = (shift, date) => {
// 	/*console.log("get shift time bounds by timestamp params: ", {
// 		shift, date, options
// 	})*/
//     const daysOfWeek = ['dom', 'lun', 'mar', 'mie', 'jue', 'vie', 'sab'];
//     var dayOfWeek = date.getDay(); //idx 2 = 'mar'
//     const startDayStr = shift.start_time_day;
//     const endDayStr = shift.end_time_day;
//     const startDayIdx = daysOfWeek.indexOf(startDayStr.toLowerCase());

//     var st = null;
//     var et = null;

//     const startTime = shift.start_time_hour * 60 + shift.start_time_minute;
//     const endTime = shift.end_time_hour * 60 + shift.end_time_minute;
//     let currentTime = date.getHours() * 60 + date.getMinutes();
//     let endDayIdx = daysOfWeek.indexOf(endDayStr.toLowerCase());

//     const shiftWeekDayAtEndHour = getShiftWeekDayAtEndHour(shift, date);
//     if (!isDayInShift(shift, date)){
//     //   console.log("el dia no esta en turno")
//       return false;
//     }

//     if (getNextWeekDay(endDayIdx) == shiftWeekDayAtEndHour && dayOfWeek == shiftWeekDayAtEndHour
//         && endTime < startTime && currentTime <= endTime) {
//         return true;
//     }
//     if (endTime < startTime && (currentTime >= startTime || currentTime <= endTime)) {
//         return true;
//     }
//     if (endTime >= startTime && currentTime >= startTime && currentTime <= endTime) {
//         return true;
//     }
//     return false;
// }

export const inShiftBounds = (shift, date) => {
     const timeBounds = getShiftTimeBoundsByTimestamp(shift, date);

     if (timeBounds === null) {
         return false; // La fecha no está en un día de turno válido o no se pudieron calcular los límites
     }

     const dateTimestamp = date.getTime();
     const stTimestamp = timeBounds.st.getTime();
     const etTimestamp = timeBounds.et.getTime();

     // Comprueba si la fecha está dentro de los límites de tiempo calculados
     return dateTimestamp >= stTimestamp && dateTimestamp <= etTimestamp;
};

export function getTimeBoundsFromShiftList(shiftList, date = new Date(), options = {}){
    var { st, et } = getShiftTimeBoundsByTimestamp(shiftList[0], date, options);
    var minSt = st; var maxEt = et;
    shiftList.forEach(shift => {
        const { st, et } = getShiftTimeBoundsByTimestamp(shift, date, options);
        shift['et'] = et;
        shift['st'] = st;

        if (shift['st'].getTime() < minSt.getTime()) minSt = shift['st'];
        if (shift['et'].getTime() > maxEt.getTime()) maxEt = shift['et'];
    });
    return {st: minSt, et: maxEt}
}

export function filterShiftsByIds(shiftList, ids){
    return ids.map(shiftId => shiftList.find(shift => shift.id == shiftId))
            .filter(shift => shift != undefined);
}

export function setShiftsTimeBoundsByTimestamp(shiftList, date = new Date(), options = {}){
    shiftList.forEach(shift => {
        const timeBounds = getShiftTimeBoundsByTimestamp(shift, date, options);
        if(timeBounds){
            shift['et'] = timeBounds.et;
            shift['st'] = timeBounds.st;
        }
    });
}

export const isFromPreviousDayShiftSession = (shiftSession, ts: Date) => {
    const {st, et} = getShiftSessionTimeBounds(shiftSession);
    if(st.getDate() === et.getDate()) return false;
    if(st.getTime() > ts.getTime()) return false;
    if(st.getDate() === ts.getDate()) return false;
    return ts.getTime() <= et.getTime();
}

export const inShiftSessionBounds = (shiftSession, date) => {
    const {st, et} = getShiftSessionTimeBounds(shiftSession);
    st.setSeconds(0, 0);
    et.setSeconds(0, 0);
    date = new Date(date);
    date.setSeconds(0, 0);
    const dateTimestamp = date.getTime();
    const stTimestamp = st.getTime();
    const etTimestamp = et.getTime();

    return dateTimestamp >= stTimestamp && dateTimestamp <= etTimestamp;
};

export function getShiftSessionsTimeBounds(shiftSessionList: any[]){
    if (!shiftSessionList || shiftSessionList.length === 0) return {minSt: null, maxEt: null};
    let {st: minSt, et: maxEt} = getShiftSessionTimeBounds(shiftSessionList[0]);
    shiftSessionList.forEach(shiftSession => {
        const {st, et} = getShiftSessionTimeBounds(shiftSession);
        if(st.getTime() < minSt.getTime()) minSt = st;
        if(et.getTime() > maxEt.getTime()) maxEt = et;
    });
    return {minSt, maxEt}
}

export function getShiftSessionTimeBounds(shiftSession: any){
    let st = new Date(shiftSession.real_start);
    let et = shiftSession.real_end ? new Date(shiftSession.real_end): new Date();
    return {st, et}
}

// const runTests = ()=>{
//     let countCorrect = 0;
//     for(let test of tests.tests){
//         console.log(`Testing shift: ${test.shift.start_time_day} - ${test.shift.end_time_day} de ${test.shift.start_time_hour}:${test.shift.start_time_minute} a ${test.shift.end_time_hour}:${test.shift.end_time_minute} with date ${test.date}`);
//         const dates = getShiftTimeBoundsByTimestamp(test.shift, new Date(test.date));
//         if(dates == null && test.expected.successfull == false){
//             console.log("excelente, no se encontraron fechas tal y como se esperaba")
//             countCorrect += 1;
//         }
//         if(dates == null && test.expected.successfull == true) console.log("falló, no encontro fecha que si existe");
//         if(dates!=null && test.expected.successfull == true){
//             if(dates.st.getTime() != new Date(test.expected.st).getTime()){
//                 console.log(`fecha inicio ${dates.st.toLocaleString('sv')} no coincide con esperable ${test.expected.st}`)
//             }
//             if(dates.et.getTime() != new Date(test.expected.et).getTime()){
//                 console.log(`fecha fin ${dates.et.toLocaleString('sv')} no coincide con esperable ${test.expected.et}`)
//             }
//             if(dates.st.getTime() == new Date(test.expected.st).getTime() &&
//                 dates.et.getTime() == new Date(test.expected.et).getTime()){
//                 countCorrect+=1;
//                 console.log("todo bien")
//             }else{
//               console.log("algo fallo :c")
//             }
//         }
//         if(dates!=null && test.expected.successfull==false){
//             console.log(`se esperaban las fechas ${test.expected.st} y ${test.expected.et} pero no se encontro nada`);
//         }
//     }
//     console.log(`${countCorrect}/${tests.tests.length} passed`);
// }
// runTests()
